
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/submit-form",
      function () {
        return require("private-next-pages/submit-form/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/submit-form"])
      });
    }
  